<!--最新事件-->
<template>
	<div class="flexStart">
		<p class="bigTitle">最新事件</p>
		<div class="custom-scrollbar hideBar">
			<table>
				<tr>
					<th>告警单位</th>
					<th>内容</th>
					<th>级别</th>
					<th>处理状况</th>
				</tr>
				<tr v-for="item in dataList">
					<td>{{item.unit}}</td>
					<td>{{item.info}}</td>
					<td :style="getColor(item.level)">{{item.level}}</td>
					<td>{{item.state}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				dataList: []
			}
		},
		created() {},
		mounted() {
			var axios = require('axios')
			axios({
				url: "/static/中科泛在定制/看板/数据/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				eachObject(data.newstEventList, (value, key) => {
					this[key] = value
				})
			})
		},
		destroyed() {},
		computed: {
			getColor() {
				return level => {
					var styleObject = {}
					switch (level) {
						case '紧急':
							styleObject.color = '#FF6464'
							break
						case '非紧急':
							styleObject.color = '#FF954F'
							break
					}
					return styleObject
				}
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	p.bigTitle {
		color: #00C6FF;
		font-size: 16px;
		font-weight: 500;
		width: 16px;
		height: calc(100% - 24px);
		padding: 0 24px;
		margin-top: 24px;
		border-right: 1px #0E1E50 solid;
	}

	.newstEvent .hideBar {
		height: 90%;
		margin-top: 5%;
	}
	.newstEvent table{
		width: 100%;
	}
	.newstEvent th {
		color: #80BFEC;
		font-weight: 500;
		padding: 7px 11px;
	}

	.newstEvent td {
		color: white;
		padding: 7px 11px;
	}
</style>
